export default __webpack_public_path__ + "be42827ac88aca64dbf05ab162990955.ttf";